'use client'

import { createContext, type ReactNode, useContext, useState } from 'react'

interface ModalContext {
  show: boolean
  setShow: (item: boolean) => void
}

const ModalContextC = createContext<ModalContext | undefined>(undefined)

interface ModalProviderProps {
  children: ReactNode
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [show, setShow] = useState<boolean>(false)

  const contextValue: ModalContext = {
    show,
    setShow,
  }

  return <ModalContextC.Provider value={contextValue}>{children}</ModalContextC.Provider>
}

export const useModalContext = () => {
  const context = useContext(ModalContextC)
  if (!context) {
    throw new Error('useModalContext must be used within a ModalProvider')
  }
  return context
}
